import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Switch } from '../ui/switch';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

export function AppearanceSection() {
  const { theme, setTheme } = useTheme();

  return (
    <Card data-testid="appearance-settings-card">
      <CardHeader>
        <div className="flex items-center gap-2">
          {theme === 'dark' ? (
            <Moon className="w-5 h-5 text-muted-foreground" />
          ) : (
            <Sun className="w-5 h-5 text-muted-foreground" />
          )}
          <CardTitle className="font-heading">Apparence</CardTitle>
        </div>
        <CardDescription>Personnalisez l'affichage de Clone IA</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between">
          <div>
            <p className="font-medium">Mode sombre</p>
            <p className="text-sm text-muted-foreground">Basculer entre les thèmes clair et sombre</p>
          </div>
          <Switch
            checked={theme === 'dark'}
            onCheckedChange={(checked) => setTheme(checked ? 'dark' : 'light')}
            data-testid="dark-mode-switch"
          />
        </div>
      </CardContent>
    </Card>
  );
}
